import React, { useState, useEffect } from "react";
import { FaCartArrowDown } from "react-icons/fa6";
import { MdDeleteForever } from "react-icons/md";
import { Link, NavLink, useNavigate } from "react-router-dom";
import "./QrCartItems.css";
import axios from 'axios';
// import { apiOutletInfo } from '../QrMenuFunctions';
import CustomerAddress from "../CustomerAddress/CustomerAddress";



const QrCartItems = () => {

    const stored = localStorage.getItem("selectedAddressId");
    const defaultAddId = stored !== null ? parseInt(stored) : null;

    const [deliveryOption, setDeliveryOption] = useState('Take Away');
    const [selectedAddressId, setSelectedAddressId] = useState(defaultAddId);
    const navigate = useNavigate()
    const [cartItems, setCartItems] = useState([]);
    const [showTotalBill, setshowTotalBill] = useState(null)
    const [addressConfirm, setAddressConfirm] = useState("Yes")
    const UpdateAndAddAddressId = parseInt(localStorage.getItem("UpdateAndAddAddressId"));
    const outletdataLocal = JSON.parse(localStorage.getItem("outletdataLocal"));
   const MaxDistance = outletdataLocal?.data?.[0]?.maxDistance || 0;
    const [distencemessage, setMessageDistence] = useState("")
    

    console.log("MaxDistence", MaxDistance);

    const API_BASE_URL = process.env.REACT_APP_API_KEY;

    const [customerData, setCustomerData] = useState(null)


    const [selectedCustomerAddress, setSelectedCustomerAddress] = useState(null)



    const customerLatitude = selectedCustomerAddress?.latitude || null;
    const customerLongitude = selectedCustomerAddress?.longitude || null;

    console.log(" selectedCustomerAddress:", customerLatitude);
    console.log(" selectedCustomerAddress:", customerLongitude);



    const outletDataParsed = JSON.parse(localStorage.getItem("outletdataLocal")) || {};
const outletInfo = Array.isArray(outletDataParsed.data) && outletDataParsed.data.length > 0
  ? outletDataParsed.data[0]
  : null;

const outletLat = outletInfo?.latitude || null;
const outletLon = outletInfo?.longitude || null;

console.log("Outlet Latitude:", outletLat);
console.log("Outlet Longitude:", outletLon);




    const [delDistance, setDelDistance] = useState(null)


    const logindata = localStorage.getItem("loginDetails");
    let enableOrder = false;

    let custId = "";
    let preAdd = "";

    if (logindata) {
        const parsedData = JSON.parse(logindata); // Parse the stored JSON string
        custId = parsedData.customerId || "";
        preAdd = parsedData.preferredAddress || "";
        enableOrder = true;

        console.log("Customer ID:", custId);
        console.log("Preferred Address:", preAdd);
    }

    const [orderData, setOrderData] = useState({
        outletId: "",
        orderType: deliveryOption,
        orderDetails: [],
        orderMessage: "",
        customerId: custId,
        deliveryDetail: [],
        deliveryAddress: selectedAddressId !== null ? Number(selectedAddressId) : null,  // ✅ Use nullish coalescing for better behavior
        deliveryInstructions: "",  // ✅ Typo fixed (was "deliveryInstrunctions")
    });

    // const OutletInfoData = localStorage.getItem("outletInfo");
    const [outletinfo, setOutletInfo] = useState([]);

   

    // ✅ Ensure `deliveryAddress` updates when `selectedAddressId` changes
    useEffect(() => {
        setOrderData((prev) => ({
            ...prev,
            deliveryAddress: selectedAddressId !== null ? Number(selectedAddressId) : null,
        }));
    }, [selectedAddressId]);

    // ✅ Ensure `orderType` updates when `deliveryOption` changes
    useEffect(() => {
        setOrderData((prev) => ({
            ...prev,
            orderType: deliveryOption,
        }));
    }, [deliveryOption]);

    console.log(orderData);




const calculateDistance = async () => {
  try {
    if (!selectedAddressId) {
      const storedId = JSON.parse(localStorage.getItem("UpdateAndAddAddressId"));
      if (storedId) setSelectedAddressId(storedId);
    }

    if (!customerLatitude || !customerLongitude || !outletLat || !outletLon) {
      console.warn("Coordinates missing.");
      return;
    }

    const response = await axios.get(
      `${API_BASE_URL}distance/calculate?origin=${customerLatitude},${customerLongitude}&destination=${outletLat},${outletLon}`
    );

    const data = response.data;

    if (data.status !== "OK") {
      console.error("API status not OK:", data.status);
      return;
    }

    const elements = data?.rows?.[0]?.elements;

    if (!elements || elements.length === 0) {
      console.error("No elements returned by API:", data);
      return;
    }

    const element = elements[0];

    if (!element || element.status !== "OK") {
      console.error("Element status not OK:", element?.status, data);
      return;
    }

    const distanceText = element.distance?.text || "0 km";
    const distanceMeters = element.distance?.value || 0;
    const durationMinutes = Math.round((element.duration?.value || 0) / 60) + (preparationTime || 0);

    setDelDistance({ distance: distanceText, distanceMeters, duration: durationMinutes });
    setAddressConfirm("Yes");
    setOrderData((prev) => ({ ...prev, distance: distanceText, distanceMeters, duration: durationMinutes }));
    setshowTotalBill(1);

  } catch (error) {
    console.error("Error fetching distance:", error);
  }
};


    
    
      





    // Fetch items from local storage on component mount
    useEffect(() => {
        const storedItems = JSON.parse(localStorage.getItem("selectedItems")) || [];
        const itemsWithQuantity = storedItems.map((item) => ({
            ...item,
            // Initialize quantity as 1
        }));
        setCartItems(itemsWithQuantity);
        // apiOutletInfo(setOutletInfo);
        apiOutletInfo()
    }, []);

    const storedData = JSON.parse(localStorage.getItem("outletdataLocal")) || {};

let outletId, outletlogo, outletName, kotPassword, kotOrderRequired, gstReq, gstPer, freeDistance, minDeliveryCharge, ratePerKm, preparationTime;

if (storedData?.data && Array.isArray(storedData.data) && storedData.data.length > 0) {
    const outlet = storedData.data[0]; // ✅ take first element
    outletId = outlet.outletId;
    outletlogo = outlet.outletlogo;
    outletName = outlet.outletName;
    kotPassword = outlet.kotPassword;
    kotOrderRequired = outlet.kotOrderRequired;
    gstReq = outlet.applyGST;
    gstPer = outlet.gstPer;
    freeDistance = outlet.freeDistance;
    minDeliveryCharge = outlet.minDeliveryCharge;
    ratePerKm = outlet.ratePerKm;
    preparationTime = outlet.preparationTime;
} else if (storedData && typeof storedData === "object") {
    // fallback if it's direct object
    outletId = storedData.outletId;
    outletlogo = storedData.outletlogo;
    outletName = storedData.outletName;
    kotPassword = storedData.kotPassword;
    kotOrderRequired = storedData.kotOrderRequired;
    gstReq = storedData.applyGST;
    gstPer = storedData.gstPer;
    freeDistance = storedData.freeDistance;
    minDeliveryCharge = storedData.minDeliveryCharge;
    ratePerKm = storedData.ratePerKm;
    preparationTime = storedData.preparationTime;
}

    console.log("outdatatest", outletId)

    const apiOutletInfo = async () => {


        try {
            const response = await axios.get(`${API_BASE_URL}OutletInfo/GetOutletInfoByOutletId?outletId=${outletId}`);
            setOutletInfo(response.data)

        } catch (error) {
            console.error("Error fetching outlet info:", error);
        }
    };
    const distanceInDouble = delDistance?.distance ? parseFloat(delDistance.distance) : 0;// Extracts 4.4 from "4.4 km"
    const delChrgs = deliveryOption === 'Take Away'
        ? 0
        : Math.max((distanceInDouble - freeDistance) * ratePerKm, minDeliveryCharge);


    useEffect(() => {
        setOrderData((prevData) => ({
            ...prevData,
            outletId: outletId,
            orderDetails: cartItems?.map((item) => ({
                qrItemId: item.qrItemId,
                rmsItemId: item.rmsItemId,
                qrItemName: item.qrItemName,
                itemMsg: item.itemMsg,
                rate: item.ApplayRate,
                quantity: item.Qty,
                amount: item.Amount,
            })) || [],  // Default to an empty array if cartItems is undefined

            deliveryDetail: {
                ...prevData.deliveryDetail, // Preserve existing delivery details
                deliveryCharges: delChrgs.toFixed(2) || 0, // Ensure delivery charge is a number
            },
            billDetail: {
                ...prevData.billDetail,
                cgst: cgst || 0,
                sgst: sgst || 0,
                // vat:0,
                orderDeliveryCharges: delChrgs.toFixed(2) || 0,
                roundOff: rndOff || 0,
            }
        }));
    }, [cartItems, delChrgs, outletId]);


    const handleItemMsgChange = (index, value) => {
        const updatedItems = [...cartItems];
        updatedItems[index].itemMsg = value; // Update the item message for the specific item
        setCartItems(updatedItems);
        updateLocalStorage(updatedItems); // Update local storage
    };

    useEffect(() => {
        if (!customerData?.addresses?.length) return;
      
        // Use selectedAddressId or fallback to UpdateAndAddAddressId from localStorage
        const addressId = selectedAddressId ?? JSON.parse(localStorage.getItem("UpdateAndAddAddressId"));
      
        if (addressId === null || addressId === undefined)
            {
          console.warn("No addressId available for selection.");
          setSelectedCustomerAddress(null);
          return;
        }
      
        const matchedAddress = customerData.addresses.find(
          (address) => address.addressId === parseInt(addressId)
        );
      
        if (matchedAddress) {
          setSelectedCustomerAddress(matchedAddress);
        } else {
          console.warn("Address not found for ID:", addressId);
          setSelectedCustomerAddress(null);
        }
      }, [selectedAddressId, customerData]);
      


    const handleSubmit = async (e) => {
        e.preventDefault(); // Prevent page refresh



        try {

            const response = await axios.post(`${API_BASE_URL}QrOrder`, orderData)
            console.log("rspOrder", response.data);

            if (response.data?.onlineOrderStatusDetails?.length > 0) {
                const latestStatus = response.data.onlineOrderStatusDetails[0];

                // Store in local storage
                localStorage.setItem("orderStatus", latestStatus.orderStatus);
                localStorage.setItem("statusTimestamp", latestStatus.statusTimestamp);

            }
            localStorage.setItem("orderId", response.data.orderId);
            navigate("/")
            clearSelectedItems();
            localStorage.removeItem("UpdateAndAddAddressId");


        } catch (error) {
            console.log("Your Order not posted Please call waitor", error);
        }
    }
    // Handle quantity increase
    const handleIncrease = (index) => {
        const updatedItems = [...cartItems];
        updatedItems[index].Qty += 1;

        setCartItems(updatedItems);
        updateLocalStorage(updatedItems);
    };

    // Handle quantity decrease
    const handleDecrease = (index) => {
        const updatedItems = [...cartItems];
        if (updatedItems[index].Qty > 1) {
            updatedItems[index].Qty -= 1;

            setCartItems(updatedItems);
            updateLocalStorage(updatedItems);
        }
    };

    const handleDelete = (index) => {
        const updatedItems = cartItems.filter((_, i) => i !== index);
        setCartItems(updatedItems);
        updateLocalStorage(updatedItems);
    };

    const clearSelectedItems = () => {
        localStorage.removeItem("selectedItems");

        setCartItems([]);
        //setSelectedItemsCount(0)
        console.log("Selected items cleared!");
    };

    // Update local storage
    const updateLocalStorage = (items) => {
        const itemsToStore = items.map(({ outletId, rmsItemId, qrItemId, qrItemName, ApplayRate, Qty }) => ({
            outletId,
            rmsItemId,
            qrItemId,
            qrItemName,
            ApplayRate,
            Qty,
        }));
        localStorage.setItem("selectedItems", JSON.stringify(itemsToStore));
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setOrderData({ ...orderData, [name]: value });
    };

    const isPasswordMatched = orderData.password === kotPassword;


    const getCustomerInfo = async (custId) => {
        if (!custId) return; // Prevent API call if custId is empty
        try {
            const response = await axios.get(`${API_BASE_URL}CustomerMaster/Byid/${custId}`)
            setCustomerData(response.data)


        } catch (error) {
            console.log("Customer Data API error", error);

        }
    }
    useEffect(() => {
        getCustomerInfo(custId)
    }, [custId])

    const handleOptionChange = (event) => {
        const newOption = event.target.value;
        setDeliveryOption(newOption);
        setMessageDistence("")

        if (newOption == "Take Away") {
            setSelectedAddressId(null);
            setAddressConfirm("Yes")
        } else { setAddressConfirm("No") }
    };


    useEffect(() => {
        if (customerData?.preferredAddress) {
            setSelectedAddressId(customerData.preferredAddress);
        }
    }, [customerData, setSelectedAddressId]);

    const handleAddressSelect = (addressId) => {
        setSelectedAddressId(addressId);


    };

useEffect(() => {
  if (!delDistance?.distance || !MaxDistance) return;

  // Extract numeric part safely
  const distanceNum = parseFloat(delDistance.distance.replace(/[^\d.]/g, ""));
  const maxDist = Number(MaxDistance);

  if (isNaN(distanceNum) || isNaN(maxDist)) return;

  if (distanceNum > maxDist) {
    setDeliveryOption("Take Away");
    setMessageDistence(`☣️ More than ${MaxDistance} km — only Takeaway allowed.`);
  } else {
    // Optional: reset message if within limit
    setMessageDistence("");
  }
}, [delDistance, MaxDistance]);





    useEffect(() => {
        if (customerData) {
            localStorage.setItem("customerData", JSON.stringify(customerData));

            const addressIdx = selectedAddressId !== null
                ? customerData.addresses?.findIndex(address => address.addressId === selectedAddressId)
                : null;

            localStorage.setItem("addressIndex", addressIdx !== null ? addressIdx.toString() : "");
            localStorage.setItem("selectedAddressId", selectedAddressId);
            localStorage.setItem("totalAddresses", ((customerData?.addresses?.length || 0)).toString());
        }
    }, [customerData, selectedAddressId]);

    const ItemAmt = cartItems.reduce(
        (total, item) => total + item.ApplayRate * item.Qty,
        0
    )

    const updateAddIndex = () => {
        const selectedAddId = JSON.parse(localStorage.getItem("selectedAddressId"));



        const addressIdx = selectedAddId !== null
            ? customerData.addresses?.findIndex(address => address.addressId == selectedAddId)
            : null;
        console.log("add", addressIdx);

        localStorage.setItem("addressIndex", addressIdx);
        localStorage.setItem("getAddress", "1")

    }



    const cgst = gstPer !== null && gstPer !== 0 ? (ItemAmt * gstPer) / 200 : 0;
    const sgst = gstPer !== null && gstPer !== 0 ? (ItemAmt * gstPer) / 200 : 0;
    const totAmt = ItemAmt + cgst + sgst + delChrgs
    const rndOff = Math.round(totAmt) - totAmt


    return (
        <>
            <div className="container-fluid">
                <div className="col-md-12">
                    <div className="row">
                        <nav className="navbar navbar-light bg-light shadow-sm bg-body rounded">
                            <div className="container-fluid">
                                <a className="navbar-brand" href="#">
                                    <img
                                        src={outletlogo}
                                        alt=""
                                        width={60}
                                        height={40}
                                        className="d-inline-block align-text-center me-2 img-fluid"
                                    />
                                    <strong className='mt-5'>
                                        {outletName}

                                        {logindata === null && (
                                            <Link to="/Login">
                                                <button type="button" className="btn btn-primary" style={{ marginLeft: "50px" }}
                                                    onclick={localStorage.setItem("backPaath", "/QrCartItems")}
                                                >
                                                    Login
                                                </button>
                                            </Link>
                                        )}


                                    </strong>
                                </a>

                            </div>
                        </nav>
                        <div className="d-flex mt-1">
                            <FaCartArrowDown size={25} className="me-2" />
                            <h4>
                                <p>Your Cart Items</p>
                            </h4>
                            <div>
                                <Link to="/QrMenuPage">
                                    <button type="button" className='btn btn-outline-info p-0'
                                        style={{ height: "25px", marginTop: "1px", marginLeft: "78px" }}
                                        onClick={clearSelectedItems}
                                    >
                                        Clear Cart
                                    </button>
                                </Link>
                            </div>
                        </div>

                        <table className="cartTblcss">
                            <thead>
                                <tr className="border border-1 border-info">
                                    <td className="border border-1 border-info text-center">#</td>
                                    <td className="border border-1 border-info">Item Name</td>
                                    <td className="border border-1 border-info">Amount</td>
                                    <td className="border border-1 border-info">Quantity</td>
                                </tr>
                            </thead>
                            <tbody>
                                {cartItems.length > 0 ? (
                                    cartItems.map((item, index) => (
                                        <tr key={item.qrItemId}>
                                            <td
                                                style={{ width: "10%" }}
                                                className="border border-1 border-info text-center"
                                            >
                                                <MdDeleteForever size={25} color="red"
                                                    style={{ cursor: "pointer" }}
                                                    onClick={() => handleDelete(index)}
                                                />
                                            </td>
                                            <td
                                                style={{ width: "55%" }}
                                                className="border border-1 border-info"
                                            >
                                                {item.qrItemName}
                                                <input
                                                    type="text"
                                                    value={item.itemMsg || ""}
                                                    placeholder="Enter Item Message"
                                                    style={{ height: "20px", width: "90%", marginLeft: "8px" }}
                                                    onChange={(e) => handleItemMsgChange(index, e.target.value)} // Handle input change for item message
                                                />
                                            </td>
                                            <td
                                                style={{ width: "15%" }}
                                                className="border border-1 border-info text-end"
                                            >
                                                {item.ApplayRate == 0 ? "APS" : item.ApplayRate * item.Qty}
                                            </td>
                                            <td
                                                style={{ width: "20%" }}
                                                className="border border-1 border-info"
                                            >
                                                <div
                                                    className="btn-group btn-group-sm"
                                                    role="group"
                                                    aria-label="Quantity control"
                                                >
                                                    <button
                                                        type="button"
                                                        className="btn btn-danger"
                                                        onClick={() => handleDecrease(index)}
                                                    >
                                                        -
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className="btn btn-warning"
                                                        disabled
                                                    >
                                                        {item.Qty}
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className="btn btn-success"
                                                        onClick={() => handleIncrease(index)}
                                                    >
                                                        +
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td
                                            colSpan="4"
                                            className="text-center border border-1 border-info"
                                        >
                                            No items in the cart
                                        </td>
                                    </tr>
                                )}
                            </tbody>

                            <tfoot>
                                <tr>
                                    <td
                                        colSpan="2"
                                        className="text-end border border-1 border-info"
                                    >
                                        <strong>Item Amount:</strong>
                                    </td>
                                    <td
                                        colSpan="2"
                                        className="text-end border border-1 border-info"
                                    >
                                        <strong>
                                            {ItemAmt}
                                        </strong>
                                    </td>
                                </tr>
                                <tr>
                                    <td
                                        colSpan="2"
                                        className="text-end border border-1 border-info"
                                    >
                                        <strong>CGST 2.5%:</strong>
                                    </td>
                                    <td
                                        colSpan="2"
                                        className="text-end border border-1 border-info"
                                    >
                                        <strong>
                                            {cgst}
                                        </strong>
                                    </td>
                                </tr>
                                <tr>
                                    <td
                                        colSpan="2"
                                        className="text-end border border-1 border-info"
                                    >
                                        <strong>SGST 2.5%:</strong>
                                    </td>
                                    <td
                                        colSpan="2"
                                        className="text-end border border-1 border-info"
                                    >
                                        <strong>
                                            {sgst}
                                        </strong>

                                    </td>
                                </tr>
                                <tr>
                                    <td
                                        colSpan="2"
                                        className="text-end border border-1 border-info"
                                    >
                                        <strong>Delivery Charges:</strong>
                                    </td>
                                    <td
                                        colSpan="2"
                                        className="text-end border border-1 border-info"
                                    >
                                        <strong>
                                            {delChrgs.toFixed(2)}
                                        </strong>
                                    </td>

                                </tr>
                                <tr>
                                    <td
                                        colSpan="2"
                                        className="text-end border border-1 border-info"
                                    >
                                        <strong>Round Off:</strong>
                                    </td>
                                    <td
                                        colSpan="2"
                                        className="text-end border border-1 border-info"
                                    >
                                        <strong>
                                            {rndOff}

                                        </strong>

                                    </td>

                                </tr>
                                <tr>
                                    <td
                                        colSpan="2"
                                        className="text-end border border-1 border-info"
                                    >
                                        <strong>Total Amount:</strong>
                                    </td>
                                    <td
                                        colSpan="2"
                                        className="text-end border border-1 border-info"
                                    >
                                        <strong>
                                            {Math.round(totAmt)}
                                        </strong>

                                    </td>
                                </tr>
                                {/* {delChrgs > 0 && (

)} */}




                            </tfoot>
                        </table>


                        <div className="mt-1">
                            <textarea type="text" className="form-control"
                                placeholder="Enter Order Message"
                                name="orderMessage"
                                value={orderData.orderMessage}
                                onChange={handleInputChange} />

                        </div>
                        {outletinfo.map((index) => (
                            <p style={{ fontSize: "13px" }}>
                                {index.taxType}
                            </p>
                        ))}


                        <div>
                            <div className="d-flex justify-content-center">
                                <div className="form-check me-3">
                                    <input
                                        className="form-check-input"
                                        type="radio"
                                        name="flexRadioDefault"
                                        id="flexRadioDefault1"
                                        value="Delivery"
                                        checked={deliveryOption === 'Delivery'}
                                        
                                        onChange={handleOptionChange}
                                    />
                                    <label className="form-check-label" htmlFor="flexRadioDefault1">
                                        Delivery
                                    </label>
                                </div>
                                <div className="form-check">
                                    <input
                                        className="form-check-input"
                                        type="radio"
                                        name="flexRadioDefault"
                                        id="flexRadioDefault2"
                                        value="Take Away"
                                        checked={deliveryOption === 'Take Away'}
                                        onChange={handleOptionChange}
                                    // onClick={setSelectedAddressId(null)}
                                    />
                                    <label className="form-check-label" htmlFor="flexRadioDefault2">
                                        Take Away
                                    </label>
                                </div>
                            </div>




                            {deliveryOption === 'Delivery' && customerData ? (
                                <div className="customer-info mt-2">
                                    <h6>Name: {customerData.customerName}</h6>
                                    <div className="d-flex">
                                        <h5 className="me-5">Address</h5>
                                    </div>


                                    <div className="address">
  {customerData.addresses
    ?.filter((item) =>
      UpdateAndAddAddressId !== null && !isNaN(UpdateAndAddAddressId)
        ? item.addressId === UpdateAndAddAddressId
        : true
    )
    .map((item) => (
      <div key={item.addressId}>
        <div className="d-flex shadow-sm p-1 mb-1 bg-body rounded align-items-center">
          {/* Show radio for selection only if not the one just added */}
          {item.addressId !== UpdateAndAddAddressId && (
            <div className="form-check me-2">
              <input
                className="form-check-input"
                type="radio"
                name="preferredAddress"
                checked={item.addressId === selectedAddressId}
                onChange={() => handleAddressSelect(item.addressId)}
              />
            </div>
          )}

          <p className="mb-0">
            {item.addLine1}, {item.addLine2}, {item.nearBy}, {item.area},{" "}
            {item.city}, {item.state}, {item.pincode}
            {item.addressId === selectedAddressId && (
              <span className="ms-2 badge bg-success">Selected</span>
            )}
          </p>
        </div>
      </div>
    ))}
</div>




                                    {selectedAddressId !== null && (
                                        <>
                                            <h6 className="mt-2">
                                                {`Distance: ${delDistance?.distance || "N/A"} | Duration: ${delDistance?.duration || "N/A"} Minutes`}
                                            </h6>


                                        </>
                                    )}






                                    <div className="d-flex mt-2 justify-content-between w-100">
                                        {selectedAddressId !== null && (
                                            <NavLink className={"btn btn-primary me-5"} to={{ pathname: '/AddressUpdate' }}
                                                onClick={updateAddIndex}
                                            >
                                                Update
                                            </NavLink>)}
                                        <button className="btn btn-success "

                                            disabled={!enableOrder || (deliveryOption == "Delivery" && (selectedAddressId == null || selectedAddressId == undefined))}
                                            onClick={calculateDistance}
                                        >
                                            Confirm
                                        </button>


                                        <NavLink className={"btn btn-primary ms-auto"} to={{ pathname: '/CustomerAddress' }}
                                            onClick={() => localStorage.setItem("getAddress", "0")}
                                        >
                                            Add New
                                        </NavLink>
                                    </div>

                                </div>
                            ) : deliveryOption === 'Delivery' ? (
                                <p>Login to Submit Order...</p>
                            ) : null}
                        </div>
                        <div className="mt-2 mb-2">
                            <input className="form-control"
                                type="text"
                                placeholder="Enter Delivery/Take Away Instructions"
                                name="deliveryInstructions"
                                value={orderData.deliveryInstructions}
                                onChange={handleInputChange}
                            />

                        </div>
                        <div className="d-flex justify-content-center mt-2">

                        </div>

                        {distencemessage && (
  <div className="alert alert-warning mt-2">
    {distencemessage}
  </div>
)}

                        <div className="d-flex justify-content-center mt-2">


                            <button className="btn btn-success "
                                disabled={!enableOrder || (deliveryOption == "Delivery" && (selectedAddressId == null || selectedAddressId == undefined)) || addressConfirm == "No"}
                                onClick={handleSubmit}
                            >
                                Order Submit
                            </button>

                        </div>

                    </div>
                </div>
            </div>
        </>
    );
};

export default QrCartItems; 